import React, { useState, useEffect, useRef } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ImgRed from '../../images/red-bullet.gif';
import ImgOrange from '../../images/orange-bullet.gif';
import ImgGreen from '../../images/green-bullet.gif';
import ImgEQ from "../../images/EQ_Blue.png";
import ImgFL from "../../images/fl_blue.gif";
import ImgNL from "../../images/NL_Blue.png";
import ImgT2 from "../../images/T2_Blue.png";
import ImgTC from "../../images/TC_Blue.png";
import "../register.css";
import * as FaIcons from 'react-icons/fa';
import { Envelope, EnvelopeFill, Phone, Telephone } from 'react-bootstrap-icons';
import { getAPI } from '../GdacsAPI';

const ServiceEditor = (props) => {
    const [servicestypes, setServicesTypes] = React.useState([]);
    const [servicestypesdevice, setServicesTypesDevice] = React.useState([]);
    const intialObject = React.useState({ idServiceType: "", eventType: "", alertLevel: "", region: "", language: "", stopNight: false, enabled: true });
    const [alertsBycode, setAlertsBycode] = React.useState([])
    const [optionList, setOptionList] = React.useState([]);
    const [alertLevel, setAlertLevel] = React.useState(!props.service?.idServiceType === 1 && !props.service?.eventType === "NL" ? ["Green"] : !props.service?.idServiceType === 1 ? ["Red", "Orange", "Green"] : !props.service?.idServiceType === 3 ? ["Red", "Orange"] : ["Red", "Orange", "Green"]);
    const [language, setLanguage] = React.useState([]);
    const [regions, setRegions] = React.useState([]);
    const [eventtypes, setEventTypes] = React.useState([]);
    const [enabled, setEnabled] = React.useState([]);
    const [service, setService] = React.useState(!props.service ? intialObject : props.service);
    const [toggleContents, setToggleContents] = React.useState();
    const [toggleEvents, setToggleEvents] = React.useState();
    const [toggleAlerts, setToggleAlerts] = React.useState();
    const [toggleRegions, setToggleRegions] = React.useState();
    const [toggleLanguages, setToggleLanguages] = React.useState();
    const [serviceDisabled, setServiceDisabled] = React.useState(!props.service ? false : props.service.eventType === "NL" ? true : false);
    const [alertDisabled, setAlertDisabled] = React.useState(!props.service ? false : props.service.eventType === "NL" ? true : false);
    const [regionDisabled, setRegionDisabled] = React.useState(!props.service ? false : props.service.eventType === "NL" ? true : false);
    const [languageDisabled, setLanguageDisabled] = React.useState(!props.service ? false : props.service.eventType === "NL" ? true : false);

    const icons = {
        "1": <><EnvelopeFill color="#0099CC" size={18} /> - EMAIL</>,
        "3": <><Telephone color="#0099CC" size={18} /> - SMS</>,
        "10": <><Phone color="#0099CC" size={18} /> - APP</>,
        "Red": <><img src={ImgRed} className="icon_table" /> - Red</>,
        "Orange": <><img src={ImgOrange} className="icon_table" /> - Orange </>,
        "Green": <><img src={ImgGreen} className="icon_table" /> - Green</>,
        "EQ": <><img src={ImgEQ} className="icon_table" /> - Earthquakes</>,
        "FL": <><img src={ImgFL} className="icon_table" /> - Floods</>,
        "NL": <><img src={ImgNL} className="icon_table" /> - Newsletter</>,
        "T2": <><img src={ImgT2} className="icon_table" /> - Tropical cyclones (6 hourly advisories)</>,
        "TC": <><img src={ImgTC} className="icon_table" /> - Tropical cyclones</>,
    };

    async function GetServicesTypes() {
        var url = getAPI() + `api/register/Definition/servicetype/`;
        const response = await fetch(url);
        if (!response.ok) {
            setServicesTypes('Failed to retreive services types data.');
            return;
        }
        const servicesTypesData = await response.json();
        const obj = [...servicesTypesData];
        let servicesFiltered = [];

        if (service.eventType === "T2") {
            for (var i = 0; i < obj.length; i++) {
                if (obj[i].idServiceType === 1 || obj[i].idServiceType === 10) {
                    let servtype = obj.find((item) => (item.idServiceType === obj[i].idServiceType));
                    servicesFiltered.push(servtype);
                }
            }
        }

        if (service.eventType === "T2") {
            setServicesTypes(servicesFiltered);
            setServicesTypesDevice(servicesFiltered);
            setLanguage(servicesTypesData[1].listLanguages);
        }
        else {
            setServicesTypes(servicesTypesData);
            setServicesTypesDevice(servicesTypesData);
            setLanguage(servicesTypesData[1].listLanguages);
        }
    }

    async function GetRegions() {
        var url = getAPI() + `api/register/Definition/regions/`;
        const response = await fetch(url);
        if (!response.ok) {
            setRegions('Failed to retreive regions data.');
            return;
        }
        const regionsData = await response.json();
        if (regionsData) {
            setRegions(regionsData);
        }
    }

    async function GetEventTypes() {
        var url = getAPI() + `api/register/Definition/eventtypes/`;
        const response = await fetch(url);
        if (!response.ok) {
            setEventTypes('Failed to retreive event types data.');
            return;
        }
        const eventtypesData = await response.json();
        if (eventtypesData) {
            setEventTypes(eventtypesData);
        }
    }
    async function GetAlertsByChannel(idservicetype) {
        var url = getAPI() + `api/register/Definition/JoinESAllByIdservice?idService=` + idservicetype;
        const response = await fetch(url);
        if (!response.ok) {
            setAlertsBycode('Failed to retreive services types data.');
            return;
        }

        const servicesAlerts = await response.json();

        let lang = servicestypesdevice.filter(x => x.idServiceType === idservicetype);

        if (servicesAlerts) {
            setAlertLevel(servicesAlerts[0].listAlertlevels);
            setToggleAlerts(icons[servicesAlerts[0].listAlertlevels]);
            setLanguage(lang[0].listLanguages);
            setToggleLanguages(lang[0].listLanguages[0].value);
        }
    }

    async function GetAlerts(eventtype) {
        var url = getAPI() + `api/register/Definition/JoinESAllByCode?code=` + eventtype;
        const response = await fetch(url);
        if (!response.ok) {
            setAlertsBycode('Failed to retreive services types data.');
            return;
        }

        const servicesAlerts = await response.json();
        const obj = [...servicesAlerts];

        let p = obj.filter(a => a.eventtypecode === eventtype);

        const filter = [...servicestypesdevice];
        /*        setServicesTypes([]);*/

        let a = [];

        for (var i = 0; i < p.length; i++) {

            const idtype = p[i].idservicetype;
            if (idtype === 1 || idtype === 3) {
                let servtype = filter.find((item) => (item.idServiceType === idtype));

                a.push(servtype);
            }
        }

        if (servicesAlerts) {
            setAlertsBycode(servicesAlerts);
            setServicesTypes(a);
            setToggleContents(icons[a[0].idServiceType]);
            setAlertLevel(p[0].listAlertlevels);
            setToggleAlerts(icons[p[0].listAlertlevels[0]]);
            setLanguage(a[0].listLanguages);
            setToggleLanguages(a[0].listLanguages[0].value);
            if (eventtype === "NL")
                setToggleRegions(regions[0].key);
        }
    }

    React.useEffect(() => {
        if (service.idServiceType !== undefined) {
            const newValue = parseInt(service.idServiceType);
            setService((a) => ({ ...a, idServiceType: newValue }));
        }
        else {
            setService((a) => ({ ...a, idServiceType: 1 }));
        }
    }, [servicestypes]);

    React.useEffect(() => {
        if (service.eventType !== undefined) {
            setService((a) => ({ ...a, eventType: service.eventType }));
        }
        else {
            setService((a) => ({ ...a, eventType: "EQ" }));
        }
    }, [eventtypes]);

    React.useEffect(() => {
        if (service.region !== undefined) {
            const newValue = parseInt(service.region);
            setService((a) => ({ ...a, region: newValue }));
        }
        else {
            setService((a) => ({ ...a, region: 1 }));
        }
    }, [regions]);

    React.useEffect(() => {
        if (service.language !== undefined) {
            const newValue = service.language;
            setService((a) => ({ ...a, language: newValue }));
        }
        else {
            const newValue = "en";
            setService((a) => ({ ...a, language: newValue }));
        }
    }, [language]);

    React.useEffect(() => {
        if (service.alertLevel !== undefined) {
            const newValue = service.alertLevel;
            if (service.eventType === "NL")
                setService((a) => ({ ...a, alertLevel: "Green" }));
            else
                setService((a) => ({ ...a, alertLevel: newValue }));
        }
        else {
            const newValue = "Red";
            setService((a) => ({ ...a, alertLevel: newValue }));
        }
    }, [alertLevel]);

    React.useEffect(() => {
        if (service.enabled === undefined)
            setService((a) => ({ ...a, enabled: true }));
    }, [enabled]);

    React.useEffect(() => {
        if (service.stopNight === undefined)
            setService((a) => ({ ...a, stopNight: false }));
    }, [enabled]);

    const handleChangeEvent = (e) => {
        setService((a) => ({ ...a, eventType: e }));
        if (e === "NL") {
            setServiceDisabled(true);
            setAlertDisabled(true);
            setRegionDisabled(true);
            setLanguageDisabled(true);
        }
        else {
            setServiceDisabled(false);
            setAlertDisabled(false);
            setRegionDisabled(false);
            setLanguageDisabled(false);
        }
    }

    const handleChangeService = (e) => {
        setService((a) => ({ ...a, idServiceType: parseInt(e) }));
    }

    const handleChangeAlertLevel = (e) => {
        setService((a) => ({ ...a, alertLevel: e }));
    }

    const handleChangeRegion = (e) => {
        setService((a) => ({ ...a, region: parseInt(e) }));
    }

    const handleChangeLanguage = (e) => {
        setService((a) => ({ ...a, language: e }));
    }

    const handleChangeCheckNight = (e) => {
        const newValue = e.currentTarget.checked;
        setService((a) => ({ ...a, stopNight: newValue }));
    };

    const handleChangeCheckEnabled = (e) => {
        const newValue = e.currentTarget.checked;
        setService((a) => ({ ...a, enabled: newValue }));
    };

    useEffect(() => {
        GetServicesTypes();
        GetRegions();
        GetEventTypes();
    }, [])

    return (
        <div>
            <form>
                <div>
                    <label className="label_mobile" htmlFor="eventTypes" >Event Type :</label>
                    <Dropdown onSelect={eventKey => {
                        setToggleEvents(icons[eventKey]);
                    }}>
                        <Dropdown.Toggle id="dropdown-custom-components" variant="light">
                            {!toggleEvents ? eventtypes.filter(item => item.eventtype === service.eventType).map(types => (
                                <><img src={`Images/${types.eventtype}_Blue.png`} className="icon_table" /> - {types.description}</>
                            )) : toggleEvents}
                        </Dropdown.Toggle>

                        <Dropdown.Menu onSelect={handleChangeService} value={service.eventtype} style={{ width: "100%" }}>
                            {
                                eventtypes.map((item) => {
                                    return (<Dropdown.Item value={item.eventtype} key={item.eventtype} eventKey={item.eventtype} onClick={e => GetAlerts(item.eventtype)} onSelect={handleChangeEvent} >
                                        <img src={`Images/${item.eventtype}_Blue.png`} className="icon_table" /> - {item.description}
                                    </Dropdown.Item>)
                                })
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <br />
                <div>
                    <label className="label_mobile" htmlFor="alertLevel">Channel :</label>
                    <Dropdown onSelect={eventKey => {
                        setToggleContents(icons[eventKey]);
                    }}>
                        <Dropdown.Toggle id="dropdown-custom-components" variant="light" disabled={serviceDisabled}>
                            {!toggleContents ? servicestypes.filter(item => item.idServiceType === service.idServiceType).map(types => (
                                types.idServiceType === 1 ?
                                    <><EnvelopeFill color="#0099CC" size={18} /> - {types.codeServiceType}</>
                                    : types.idServiceType === 3 ? <><Telephone color="#0099CC" size={18} /> - {types.codeServiceType}</>
                                        : <><Phone color="#0099CC" size={18} /> - {types.codeServiceType}</>
                            )) : toggleContents}
                        </Dropdown.Toggle>

                        <Dropdown.Menu onSelect={handleChangeService} value={service.idServiceType} >
                            {
                                servicestypes.map((item) => {
                                    return (<Dropdown.Item value={item.idServiceType} key={item.idServiceType} eventKey={item.idServiceType} onClick={e => GetAlertsByChannel(item.idServiceType)} onSelect={handleChangeService} >
                                        {item.idServiceType === 1 ?
                                            <><EnvelopeFill color="#0099CC" size={18} /> - {item.codeServiceType}</>
                                            : item.idServiceType === 3 ? <><Telephone color="#0099CC" size={18} /> - {item.codeServiceType}</>
                                                : <><Phone color="#0099CC" size={18} /> - {item.codeServiceType}</>
                                        }
                                    </Dropdown.Item>)
                                })
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <br />
                <div >
                    <label className="label_mobile" htmlFor="region">Alert Level :</label>
                    <Dropdown onSelect={eventKey => {
                        setToggleAlerts(icons[eventKey]);
                    }}>
                        <Dropdown.Toggle id="dropdown-custom-components" variant="light" disabled={alertDisabled}>
                            {!toggleAlerts ? <img src={`Images/${service.alertLevel}-bullet.gif`} className="icon_table" /> : toggleAlerts}
                        </Dropdown.Toggle>
                        <Dropdown.Menu >
                            {
                                alertLevel.map((item, index) => {
                                    return (<Dropdown.Item id={item} value={item} key={index} eventKey={item} onSelect={handleChangeAlertLevel} >
                                        <img src={`Images/${item}-bullet.gif`} className="icon_table" /> - {item}
                                    </Dropdown.Item>)
                                })
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <br />
                <div>
                    <label className="label_mobile" htmlFor="serviceType">Region :</label>
                    <Dropdown onSelect={eventKey => {
                        setToggleRegions(<>
                            {regions.filter(item => item.idRegion === parseInt(eventKey)).map(types => (
                                <>
                                    {types.regionName}
                                </>
                            ))}
                        </>);
                    }}>
                        <Dropdown.Toggle id="dropdown-custom-components" variant="light" disabled={regionDisabled}>
                            {!toggleRegions ? regions.filter(item => item.idRegion === service.region).map(types => (
                                <>
                                    {types.regionName}
                                </>
                            )) : toggleRegions}
                        </Dropdown.Toggle>

                        <Dropdown.Menu value={service.region} style={{ maxHeight: 300, overflowY: 'scroll' }}>
                            {
                                regions.map((item) => {
                                    return (<Dropdown.Item value={item.idRegion} key={item.idRegion} eventKey={item.idRegion} onSelect={handleChangeRegion} >
                                        {item.regionName}
                                    </Dropdown.Item>)
                                })
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <br />
                <div>
                    <label className="label_mobile" htmlFor="language">Language :</label>
                    <Dropdown onSelect={eventKey => {
                        setToggleLanguages(<>
                            {language.filter(item => item.key === eventKey).map(types => (
                                <>
                                    {types.value}
                                </>
                            ))}
                        </>);
                    }}>
                        <Dropdown.Toggle id="dropdown-custom-components" variant="light" disabled={languageDisabled}>
                            {!toggleLanguages ? language.filter(item => item.key === service.language).map(types => (
                                <>
                                    {types.value}
                                </>
                            )) : toggleLanguages}
                        </Dropdown.Toggle>

                        <Dropdown.Menu value={service.language}>
                            {
                                language.map((item) => {
                                    return (<Dropdown.Item value={item.key} key={item.key} eventKey={item.key} onSelect={handleChangeLanguage} >
                                        {item.value}
                                    </Dropdown.Item>)
                                })
                            }
                        </Dropdown.Menu>
                    </Dropdown>

                </div>
                <br />
                <div className="row">
                    <div className="col-6">
                        <label className="label_mobile" htmlFor="night" style={{ textAlign: "left" }}>Stop Night :</label>
                    </div>
                    <div className="col-6 row">
                        <input name="stopNight" className="input-checkbox" defaultChecked={service.stopNight} type="checkbox" onChange={handleChangeCheckNight} />
                    </div>
                    <div className="col-6">
                        <label className="label_mobile" htmlFor="enabled" style={{ textAlign: "left" }}>Enabled :</label>
                    </div>
                    <div className="col-6 row">
                        <input name="enabled" className="input-checkbox" defaultChecked={service.enabled} type='checkbox' onChange={handleChangeCheckEnabled} />
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-6" style={{ textAlign: "center" }}>
                        <button type='button' className="btn btn-info" onClick={() => props.onRequestSaveService(service)}>Save</button> &nbsp;
                </div>
                    <div className="col-6" style={{ textAlign: "center" }}>
                        <button type='button' className="btn btn-info" onClick={() => props.onRequestCancel(service)}>Cancel</button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export { ServiceEditor }